import { serverAdress } from '../../properties/server';

const actions = {
    loadServerAdress({commit, state}){
        commit('setServerAdress', serverAdress)
    }
};

const mutations = {
    setServerAdress(state, newAdress){
        state.serverAdress = newAdress;
    }
}

export default {
    namespaced: true,
    actions,
    mutations
  };
  